export default {
      id: "ic-failed-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic-failed-usage",
      toString: function () {
        return this.url;
      }
    }